<template>
  <div ref="flix">
    <div id="flix-minisite"></div>
    <div id="flix-inpage"></div>
  </div>
</template>

<script setup>
import {onMounted, onUpdated, ref} from "vue";
import {getActiveLanguage} from "laravel-vue-i18n";

const props = defineProps({
  product: Object,
});
const flix = ref(null);
const reMount = () => {
  let flixScript = document.createElement("script");
  flixScript.dataset.flixButton = "flix-minisite";
  flixScript.dataset.flixInpage = "flix-inpage";
  flixScript.dataset.flixDistributor = "13405";
  flixScript.dataset.flixLanguage = getActiveLanguage();
  flixScript.dataset.flixBrand = props.product.brand;
  flixScript.dataset.flixEan = props.product.barcode;
  flixScript.setAttribute("src", "https://media.flixfacts.com/js/loader.js");
  flix.value.appendChild(flixScript);
};
onUpdated(() => reMount());
onMounted(() => reMount());
</script>
